import { useAxiosModule } from '@/modules/_shared/axios'
import { WhitelistedIP } from './types'

const {
    getFromApi
} = useAxiosModule()

/* Get Whitelisted IPs list */

export type GetWhitelistedIPsResponse = WhitelistedIP[]
const getWhitelistedIPsUrl = 'system_access/ip/whitelist'

export async function getWhitelistedIPsList () {
    return getFromApi<GetWhitelistedIPsResponse>(getWhitelistedIPsUrl)
}
